import getStore from '../store';
import clamp from '../util/clamp';
import { mutator } from 'satcheljs';
import { initToolboxHeight, setToolboxHeight } from '../actions';
import { minToolboxHeight, toolDims } from '../constants';

mutator(initToolboxHeight, ({ defaultHeight }) => {
    getStore().defaultToolboxHeight = defaultHeight;
    getStore().toolboxHeight = defaultHeight;
});

mutator(setToolboxHeight, ({ height }) => {
    getStore().toolboxHeight = clamp(
        Math.floor(height / toolDims) * toolDims, // keep the height a multiple of toolDims
        minToolboxHeight,
        getStore().defaultToolboxHeight
    );
});
